import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { IBasicUserInfo, UserLoggedin } from '../models/user';
import { jwtDecode } from "jwt-decode";
import { AppService } from './app.service';
import { environment } from '../../environments/environment';

interface JwtPayload {
  id: number;
  iat: number;
  exp: number;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private router = inject(Router);
  api = environment.api
  http = inject(HttpClient);
  appService = inject(AppService);

  isAuthenticated(): boolean {
    const token = this.getCookie('user_data');
    return !this.isTokenExpired(token);
  }

  login(authData: {password: string, email: string}): void {
    this.http.post<UserLoggedin>(`${this.api}/auth/local`, authData).subscribe({
      next: (res) => {
        // this.setCookie('session', res.jwt, 1);
        const userData: IBasicUserInfo = {
          id: res.user.id,
          token: res.jwt,
          name: res.user.firstName,
          surname: res.user.lastName,
          role: res.user.assignment,
        };
  
        // Salvataggio come stringa JSON in un unico cookie
        this.setCookie('user_data', JSON.stringify(userData), 1);
        this.router.navigate(['/']);
      },
      error: (e) => {
        this.appService.onToastOpen('error', 'Error', 'Errore durante la login')
      }
    })
  }

  logout(): void {
    // this.deleteCookie('session');
    this.deleteCookie('user_data');
    this.router.navigate(['/login'])
  }

  setCookie(name: string, value: string, days: number): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; Secure; SameSite=Strict`;
  }
  
  getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      let c = cookie.trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
  
  private deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict`;
  }

  isAdmin (): boolean {
    const cookie = this.getCookie('user_data');
    const parsedCookie = cookie && JSON.parse(cookie);
    return parsedCookie.role === 'Admin';
  }

  isTokenExpired(token: string | null): boolean {
    if(token) {
      const decoded: JwtPayload = jwtDecode(token);
      if (!decoded || !decoded.exp) {
        return true;
      }
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp < currentTime;
    } else {
      return true;
    }
  }

}
